'use client';
import React from 'react';

export default function CTASection() {
  return (
    <section className="bg-[#050a0f] border-t border-[#222] py-20 lg:py-28 relative overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#80edfa]/20 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#80edfa]/20 to-transparent" />
        {/* Glowing orbs */}
        <div className="orb orb-cyan" style={{ width: '500px', height: '500px', top: '-150px', left: '-100px', opacity: 0.6 }} />
        <div className="orb orb-blue" style={{ width: '400px', height: '400px', bottom: '-100px', right: '-50px', opacity: 0.5 }} />
        {/* Scan line */}
        <div className="scan-line" />
        {/* Animated pixel squares */}
        <div className="absolute top-8 left-[10%] w-12 h-12 bg-[#181b1f] pixel-float-1" style={{ opacity: 0.4 }} />
        <div className="absolute top-16 left-[15%] w-8 h-8 bg-[#222] pixel-float-3" style={{ opacity: 0.3 }} />
        <div className="absolute bottom-8 right-[10%] w-12 h-12 bg-[#181b1f] pixel-float-2" style={{ opacity: 0.4 }} />
        <div className="absolute bottom-16 right-[15%] w-8 h-8 bg-[#222] pixel-float-4" style={{ opacity: 0.3 }} />
        {/* Sweep lines */}
        <div className="line-sweep" style={{ top: '40%', animationDelay: '1s' }} />
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24 items-start lg:items-center">
          <div className="lg:w-1/2 fade-in-left">
            <h2 className="font-heading text-[clamp(2rem,4vw,3.5rem)] text-[#f5f5f8] font-medium leading-tight">
              Stop fixing security once a year. Start doing it every day.
            </h2>
          </div>
          <div className="lg:w-1/2 flex flex-col gap-6 fade-in-right" style={{ transitionDelay: '0.2s' }}>
            <p className="text-[#aaa] text-base leading-relaxed">
              Whether you need to reach SOC2 or ISO 27001 fast, maintain compliance through an audit window, embed AppSec into your pipelines, or build a risk-led security programme from the ground up, TechSonar provides the senior engineering expertise to get you there and keep you there.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="#contact" className="btn-primary">
                Book a consultation
              </a>
              <a href="#capabilities" className="btn-secondary">
                Explore our capabilities
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
